import { redirect } from 'react-router';
import LocatorApi from '@/lib/LocatorApi';
export default async function postcodeAction({ request, params, }) {
    const postcode = params.postcode;
    const formData = await request.formData();
    const search = formData.get('search');
    const materials = await LocatorApi.getInstance().post('materials', formData);
    const material = materials.find((m) => m.name === search);
    const searchParams = new URLSearchParams();
    searchParams.set('search', search);
    if (!material) {
        return redirect(`/${postcode}/material/search?${searchParams.toString()}`);
    }
    const searchType = material.type === 'LocatorMaterialCategory' ? 'category' : 'materials';
    searchParams.set(searchType, material.id);
    return redirect(`/${postcode}/material?${searchParams.toString()}`);
}
